export default "__VITE_ASSET__DPMWGIP2__"